__turbopack_context__.v({
  "bentoCard": "BentoCard-module__DFyYBq__bentoCard",
  "caption": "BentoCard-module__DFyYBq__caption",
  "imageContainer": "BentoCard-module__DFyYBq__imageContainer",
  "textContainer": "BentoCard-module__DFyYBq__textContainer",
  "title": "BentoCard-module__DFyYBq__title",
});
